var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useCallback, useMemo } from 'react';
import { apiGetOneProffitSearchInformation } from '../../../../actions/ProffitSearchAction';
import { apiCreateProffitSearchFolder } from '../../../../actions/ProffitSearchFolderAction';
import { notify, wrapDispatch, wrapNotifyError } from '../../../action';
import { arraySortFuncMultiKeys } from '../../../common/ArrayHelper';
import { useBoolState } from '../../useHook';
import { useMyPageRouter } from './useMyPageRouter';
const useEvent = (dispatch, folders, loadFolders) => {
    const { boolState: addModalState, changeFalse: hideAddModal, changeTrue: showAddModal, } = useBoolState(false);
    const { formatQuery, onClickSort } = useMyPageRouter.useQueryParams([
        { name: 'sort', selects: ['name', 'updatedAt'] },
        { name: 'order', selects: ['asc', 'desc'] },
    ]);
    const rows = useMemo(() => [...(folders || [])].sort((leftValue, rightValue) => arraySortFuncMultiKeys(leftValue, rightValue, [
        {
            adjust: formatQuery.order === 'asc' ? 1 : -1,
            name: formatQuery.sort,
        },
        {
            adjust: 1,
            name: 'id',
        },
    ])), [folders, formatQuery.sort, formatQuery.order]);
    /**
     * 新規フォルダを作成のイベント
     * @type {(function(*=): Promise<void>)|*}
     */
    const onSubmitCreateFolder = useCallback((values) => __awaiter(void 0, void 0, void 0, function* () {
        yield wrapNotifyError(() => __awaiter(void 0, void 0, void 0, function* () {
            // フォルダの新規作成
            yield wrapDispatch(dispatch, apiCreateProffitSearchFolder(values));
            // データを引き直す（reducer側のfoldersを更新）
            yield wrapDispatch(dispatch, apiGetOneProffitSearchInformation(values));
            // フォルダ一覧を再描画
            yield loadFolders();
            notify('新規フォルダを作成しました');
            hideAddModal();
        }));
    }), [dispatch, hideAddModal, loadFolders]);
    const initialValues = useMemo(() => ({}), []);
    return {
        addModalState,
        hideAddModal,
        initialValues,
        onClickSort,
        onSubmitCreateFolder,
        order: formatQuery.order,
        rows,
        showAddModal,
        sort: formatQuery.sort,
    };
};
export const useMyPageFolder = {
    useEvent,
};
export default useMyPageFolder;
